(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './ktor-ktor-io.js', './ktor-ktor-utils.js', './ktor-ktor-http.js', './ktor-ktor-client-core.js', './kotlinx-serialization-kotlinx-serialization-json.js', './supabase-kt-supabase-kt.js', './kotlinx-serialization-kotlinx-serialization-core.js', './supabase-kt-auth-kt.js', './MultiplatformSettings-multiplatform-settings-no-arg.js', './MultiplatformSettings-multiplatform-settings-coroutines.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./ktor-ktor-io.js'), require('./ktor-ktor-utils.js'), require('./ktor-ktor-http.js'), require('./ktor-ktor-client-core.js'), require('./kotlinx-serialization-kotlinx-serialization-json.js'), require('./supabase-kt-supabase-kt.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./supabase-kt-auth-kt.js'), require('./MultiplatformSettings-multiplatform-settings-no-arg.js'), require('./MultiplatformSettings-multiplatform-settings-coroutines.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-storage-kt'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'supabase-kt-storage-kt'.");
    }
    if (typeof globalThis['ktor-ktor-io'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-storage-kt'. Its dependency 'ktor-ktor-io' was not found. Please, check whether 'ktor-ktor-io' is loaded prior to 'supabase-kt-storage-kt'.");
    }
    if (typeof globalThis['ktor-ktor-utils'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-storage-kt'. Its dependency 'ktor-ktor-utils' was not found. Please, check whether 'ktor-ktor-utils' is loaded prior to 'supabase-kt-storage-kt'.");
    }
    if (typeof globalThis['ktor-ktor-http'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-storage-kt'. Its dependency 'ktor-ktor-http' was not found. Please, check whether 'ktor-ktor-http' is loaded prior to 'supabase-kt-storage-kt'.");
    }
    if (typeof globalThis['ktor-ktor-client-core'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-storage-kt'. Its dependency 'ktor-ktor-client-core' was not found. Please, check whether 'ktor-ktor-client-core' is loaded prior to 'supabase-kt-storage-kt'.");
    }
    if (typeof globalThis['kotlinx-serialization-kotlinx-serialization-json'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-storage-kt'. Its dependency 'kotlinx-serialization-kotlinx-serialization-json' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-json' is loaded prior to 'supabase-kt-storage-kt'.");
    }
    if (typeof globalThis['supabase-kt-supabase-kt'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-storage-kt'. Its dependency 'supabase-kt-supabase-kt' was not found. Please, check whether 'supabase-kt-supabase-kt' is loaded prior to 'supabase-kt-storage-kt'.");
    }
    if (typeof globalThis['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-storage-kt'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'supabase-kt-storage-kt'.");
    }
    if (typeof globalThis['supabase-kt-auth-kt'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-storage-kt'. Its dependency 'supabase-kt-auth-kt' was not found. Please, check whether 'supabase-kt-auth-kt' is loaded prior to 'supabase-kt-storage-kt'.");
    }
    if (typeof globalThis['MultiplatformSettings-multiplatform-settings-no-arg'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-storage-kt'. Its dependency 'MultiplatformSettings-multiplatform-settings-no-arg' was not found. Please, check whether 'MultiplatformSettings-multiplatform-settings-no-arg' is loaded prior to 'supabase-kt-storage-kt'.");
    }
    if (typeof globalThis['MultiplatformSettings-multiplatform-settings-coroutines'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-storage-kt'. Its dependency 'MultiplatformSettings-multiplatform-settings-coroutines' was not found. Please, check whether 'MultiplatformSettings-multiplatform-settings-coroutines' is loaded prior to 'supabase-kt-storage-kt'.");
    }
    globalThis['supabase-kt-storage-kt'] = factory(typeof globalThis['supabase-kt-storage-kt'] === 'undefined' ? {} : globalThis['supabase-kt-storage-kt'], globalThis['kotlin-kotlin-stdlib'], globalThis['ktor-ktor-io'], globalThis['ktor-ktor-utils'], globalThis['ktor-ktor-http'], globalThis['ktor-ktor-client-core'], globalThis['kotlinx-serialization-kotlinx-serialization-json'], globalThis['supabase-kt-supabase-kt'], globalThis['kotlinx-serialization-kotlinx-serialization-core'], globalThis['supabase-kt-auth-kt'], globalThis['MultiplatformSettings-multiplatform-settings-no-arg'], globalThis['MultiplatformSettings-multiplatform-settings-coroutines']);
  }
}(function (_, kotlin_kotlin, kotlin_io_ktor_ktor_io, kotlin_io_ktor_ktor_utils, kotlin_io_ktor_ktor_http, kotlin_io_ktor_ktor_client_core, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json, kotlin_io_github_jan_tennert_supabase_supabase_kt, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_io_github_jan_tennert_supabase_auth_kt, kotlin_com_russhwolf_multiplatform_settings_no_arg, kotlin_com_russhwolf_multiplatform_settings_coroutines) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var protoOf = kotlin_kotlin.$_$.eh;
  var toString = kotlin_kotlin.$_$.hh;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.p5;
  var ByteReadChannel = kotlin_io_ktor_ktor_io.$_$.l1;
  var fromInt = kotlin_kotlin.$_$.pe;
  var toList = kotlin_kotlin.$_$.lc;
  var VOID = kotlin_kotlin.$_$.d;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  var getKClass = kotlin_kotlin.$_$.si;
  var arrayOf = kotlin_kotlin.$_$.fo;
  var createKType = kotlin_kotlin.$_$.qi;
  var TypeInfo = kotlin_io_ktor_ktor_utils.$_$.l;
  var OutgoingContent = kotlin_io_ktor_ktor_http.$_$.t;
  var NullBody_instance = kotlin_io_ktor_ktor_http.$_$.a;
  var Companion_getInstance = kotlin_io_ktor_ktor_http.$_$.c;
  var defaultForFilePath = kotlin_io_ktor_ktor_http.$_$.q1;
  var header = kotlin_io_ktor_ktor_client_core.$_$.u;
  var Default_getInstance = kotlin_kotlin.$_$.r2;
  var encodeToByteArray = kotlin_kotlin.$_$.tj;
  var add = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.m;
  var Companion_getInstance_0 = kotlin_io_ktor_ktor_http.$_$.h;
  var contentType = kotlin_io_ktor_ktor_http.$_$.o1;
  var JsonObject = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.j;
  var ReadChannelContent = kotlin_io_ktor_ktor_http.$_$.r;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var CoroutineImpl = kotlin_kotlin.$_$.xd;
  var JsonObjectBuilder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.i;
  var putJsonArray = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.s;
  var Application_getInstance = kotlin_io_ktor_ktor_http.$_$.b;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.gd;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.eg;
  var put = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.v;
  var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.b3;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var isByteArray = kotlin_kotlin.$_$.lg;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.q;
  var substringAfterLast = kotlin_kotlin.$_$.hl;
  var substringBeforeLast = kotlin_kotlin.$_$.kl;
  var bodyAsText = kotlin_io_ktor_ktor_client_core.$_$.f;
  var get_supabaseJson = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.a1;
  var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.f3;
  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t2;
  var isInterface = kotlin_kotlin.$_$.rg;
  var replace = kotlin_kotlin.$_$.xk;
  var SupabaseEncodingException = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.l;
  var MissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u2;
  var get_jsonPrimitive = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.r;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var Companion_getInstance_1 = kotlin_io_ktor_ktor_http.$_$.f;
  var isBlank = kotlin_kotlin.$_$.dk;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.uo;
  var url = kotlin_io_ktor_ktor_client_core.$_$.w;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.a4;
  var getStringHashCode = kotlin_kotlin.$_$.ag;
  var numberRangeToNumber = kotlin_kotlin.$_$.yg;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var ParametersBuilder = kotlin_io_ktor_ktor_http.$_$.z;
  var formUrlEncode = kotlin_io_ktor_ktor_http.$_$.t1;
  var Companion_getInstance_2 = kotlin_kotlin.$_$.d3;
  var DurationUnit_SECONDS_getInstance = kotlin_kotlin.$_$.t3;
  var toDuration = kotlin_kotlin.$_$.tm;
  var Long = kotlin_kotlin.$_$.kn;
  var toString_0 = kotlin_kotlin.$_$.hp;
  var Duration__toString_impl_8d916b = kotlin_kotlin.$_$.o;
  var hashCode = kotlin_kotlin.$_$.bg;
  var Duration__hashCode_impl_u4exz6 = kotlin_kotlin.$_$.g;
  var getBooleanHashCode = kotlin_kotlin.$_$.vf;
  var equals = kotlin_kotlin.$_$.sf;
  var MainConfig = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.q;
  var Companion_getInstance_3 = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.c;
  var setup = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.u;
  var SupabasePluginProvider = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.v;
  var MainPlugin = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.s;
  var _Duration___get_inWholeMilliseconds__impl__msfiry = kotlin_kotlin.$_$.i;
  var timeout = kotlin_io_ktor_ktor_client_core.$_$.p;
  var LogLevel_INFO_getInstance = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.f;
  var SerializationException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.x2;
  var UnknownRestException = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.n;
  var Companion_getInstance_4 = kotlin_io_ktor_ktor_http.$_$.j;
  var NotFoundRestException = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.j;
  var BadRequestRestException = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.i;
  var UnauthorizedRestException = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.m;
  var authenticatedSupabaseApi = kotlin_io_github_jan_tennert_supabase_auth_kt.$_$.g;
  var resolveUrl = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.r;
  var init = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.t;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g2;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.w;
  var IntSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a2;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n2;
  var objectCreate = kotlin_kotlin.$_$.dh;
  var SerializableWith = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.w2;
  var equalsLong = kotlin_kotlin.$_$.oe;
  var AtomicMutableMap = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.h;
  var PlatformUtils_getInstance = kotlin_io_ktor_ktor_utils.$_$.a;
  var Settings = kotlin_com_russhwolf_multiplatform_settings_no_arg.$_$.a;
  var toSuspendSettings = kotlin_com_russhwolf_multiplatform_settings_coroutines.$_$.a;
  //endregion
  //region block: pre-declaration
  function upload(path, data, options, $completion) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    // Inline function 'kotlin.require' call
    if (!!(data.length === 0)) {
      var message = 'The data to upload should not be empty';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return this.wx4(path, new UploadData(ByteReadChannel(data), fromInt(data.length)), options, $completion);
  }
  function delete_0(paths, $completion) {
    return this.xx4(toList(paths), $completion);
  }
  function copy$default(from, to, destinationBucket, $completion, $super) {
    destinationBucket = destinationBucket === VOID ? null : destinationBucket;
    return $super === VOID ? this.zx4(from, to, destinationBucket, $completion) : $super.zx4.call(this, from, to, destinationBucket, $completion);
  }
  function downloadPublic$default(path, options, $completion, $super) {
    var tmp;
    if (options === VOID) {
      tmp = BucketApi$downloadPublic$lambda;
    } else {
      tmp = options;
    }
    options = tmp;
    return $super === VOID ? this.bx5(path, options, $completion) : $super.bx5.call(this, path, options, $completion);
  }
  initMetadataForInterface(BucketApi, 'BucketApi', VOID, VOID, VOID, [3, 4, 1, 2]);
  initMetadataForClass(BucketApiImpl$defaultUploadRequest$1, VOID, VOID, ReadChannelContent);
  initMetadataForCoroutine($deleteCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($copyCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($normalDownloadRequestCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($uploadOrUpdateCOROUTINE$, CoroutineImpl);
  initMetadataForClass(BucketApiImpl, 'BucketApiImpl', VOID, VOID, [BucketApi], [3, 4, 2, 1]);
  initMetadataForClass(DownloadOptionBuilder, 'DownloadOptionBuilder', DownloadOptionBuilder);
  initMetadataForClass(FileUploadResponse, 'FileUploadResponse');
  initMetadataForCompanion(Companion);
  initMetadataForClass(ImageTransformation, 'ImageTransformation', ImageTransformation);
  initMetadataForClass(Resumable, 'Resumable', Resumable);
  initMetadataForClass(Config, 'Config', Config, MainConfig);
  initMetadataForCompanion(Companion_0, VOID, [SupabasePluginProvider]);
  function from(bucketId) {
    return this.je(bucketId);
  }
  initMetadataForInterface(Storage, 'Storage', VOID, VOID, [MainPlugin], [2, 1, 0]);
  initMetadataForCoroutine($parseErrorResponseCOROUTINE$, CoroutineImpl);
  initMetadataForClass(StorageImpl, 'StorageImpl', VOID, VOID, [Storage], [1, 2, 0]);
  initMetadataForCompanion(Companion_1);
  initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(StorageErrorResponse, 'StorageErrorResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
  initMetadataForClass(UploadData, 'UploadData');
  initMetadataForClass(UploadOptionBuilder, 'UploadOptionBuilder');
  initMetadataForClass(StorageAnalyticsClientImpl, 'StorageAnalyticsClientImpl', VOID, VOID, VOID, [1, 0]);
  initMetadataForClass(MemoryResumableCache, 'MemoryResumableCache', MemoryResumableCache, VOID, VOID, [2, 1, 0]);
  initMetadataForClass(ResumableClientImpl, 'ResumableClientImpl', VOID, VOID, VOID, [1, 5, 2, 4]);
  initMetadataForClass(StorageVectorsClientImpl, 'StorageVectorsClientImpl', VOID, VOID, VOID, [1]);
  initMetadataForClass(SettingsResumableCache, 'SettingsResumableCache', SettingsResumableCache, VOID, VOID, [2, 1, 0]);
  //endregion
  function BucketApi$downloadPublic$lambda(_this__u8e3s4) {
    return Unit_instance;
  }
  function BucketApi() {
  }
  function normalDownloadRequest($this, path, public_0, options, $completion) {
    var tmp = new $normalDownloadRequestCOROUTINE$($this, path, public_0, options, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function defaultUploadUrl($this, path) {
    return $this.qx5_1 + '/' + path;
  }
  function defaultUploadRequest($this, $receiver, path, data, optionBuilder) {
    // Inline function 'io.ktor.client.request.setBody' call
    var body = new BucketApiImpl$defaultUploadRequest$1(optionBuilder, path, data);
    if (body == null) {
      $receiver.bts_1 = NullBody_instance;
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp = getKClass(BucketApiImpl$defaultUploadRequest$1);
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_0;
      try {
        tmp_0 = createKType(getKClass(BucketApiImpl$defaultUploadRequest$1), arrayOf([]), false);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var _unused_var__etf5q3 = $p;
          tmp_1 = null;
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      var tmp$ret$2 = tmp_0;
      var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$2);
      $receiver.qtx(tmp$ret$1);
    } else {
      if (body instanceof OutgoingContent) {
        $receiver.bts_1 = body;
        $receiver.qtx(null);
      } else {
        $receiver.bts_1 = body;
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp_2 = getKClass(BucketApiImpl$defaultUploadRequest$1);
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_3;
        try {
          tmp_3 = createKType(getKClass(BucketApiImpl$defaultUploadRequest$1), arrayOf([]), false);
        } catch ($p_0) {
          var tmp_4;
          if ($p_0 instanceof Error) {
            var _unused_var__etf5q3_0 = $p_0;
            tmp_4 = null;
          } else {
            throw $p_0;
          }
          tmp_3 = tmp_4;
        }
        var tmp$ret$4 = tmp_3;
        var tmp$ret$3 = new TypeInfo(tmp_2, tmp$ret$4);
        $receiver.qtx(tmp$ret$3);
      }
    }
    var tmp0_elvis_lhs = optionBuilder.zx5_1;
    header($receiver, 'Content-Type', tmp0_elvis_lhs == null ? defaultForFilePath(Companion_getInstance(), path) : tmp0_elvis_lhs);
    header($receiver, 'x-upsert', optionBuilder.xx5_1.toString());
    var tmp1_safe_receiver = optionBuilder.yx5_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      header($receiver, 'x-metadata', Default_getInstance().cl(encodeToByteArray(tmp1_safe_receiver.toString())));
    }
  }
  function BucketApiImpl$api$lambda(this$0) {
    return function ($this$withDefaultRequest) {
      $this$withDefaultRequest.ats_1.gsq(this$0.sx5_1);
      return Unit_instance;
    };
  }
  function BucketApiImpl$delete$lambda($paths) {
    return function ($this$putJsonArray) {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = $paths.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        add($this$putJsonArray, element);
      }
      return Unit_instance;
    };
  }
  function BucketApiImpl$delete$lambda_0($contentType, $body) {
    return function ($this$request) {
      $this$request.ztr_1 = Companion_getInstance_0().it2_1;
      contentType($this$request, $contentType);
      // Inline function 'io.ktor.client.request.setBody' call
      var body = $body;
      if (body == null) {
        $this$request.bts_1 = NullBody_instance;
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp = getKClass(JsonObject);
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_0;
        try {
          tmp_0 = createKType(getKClass(JsonObject), arrayOf([]), false);
        } catch ($p) {
          var tmp_1;
          if ($p instanceof Error) {
            var _unused_var__etf5q3 = $p;
            tmp_1 = null;
          } else {
            throw $p;
          }
          tmp_0 = tmp_1;
        }
        var tmp$ret$3 = tmp_0;
        var tmp$ret$2 = new TypeInfo(tmp, tmp$ret$3);
        $this$request.qtx(tmp$ret$2);
      } else {
        if (body instanceof OutgoingContent) {
          $this$request.bts_1 = body;
          $this$request.qtx(null);
        } else {
          $this$request.bts_1 = body;
          // Inline function 'io.ktor.util.reflect.typeInfo' call
          var tmp_2 = getKClass(JsonObject);
          // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
          var tmp_3;
          try {
            tmp_3 = createKType(getKClass(JsonObject), arrayOf([]), false);
          } catch ($p_0) {
            var tmp_4;
            if ($p_0 instanceof Error) {
              var _unused_var__etf5q3_0 = $p_0;
              tmp_4 = null;
            } else {
              throw $p_0;
            }
            tmp_3 = tmp_4;
          }
          var tmp$ret$5 = tmp_3;
          var tmp$ret$4 = new TypeInfo(tmp_2, tmp$ret$5);
          $this$request.qtx(tmp$ret$4);
        }
      }
      return Unit_instance;
    };
  }
  function BucketApiImpl$copy$lambda($contentType, $body) {
    return function ($this$request) {
      $this$request.ztr_1 = Companion_getInstance_0().ft2_1;
      contentType($this$request, $contentType);
      // Inline function 'io.ktor.client.request.setBody' call
      var body = $body;
      if (body == null) {
        $this$request.bts_1 = NullBody_instance;
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp = getKClass(JsonObject);
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_0;
        try {
          tmp_0 = createKType(getKClass(JsonObject), arrayOf([]), false);
        } catch ($p) {
          var tmp_1;
          if ($p instanceof Error) {
            var _unused_var__etf5q3 = $p;
            tmp_1 = null;
          } else {
            throw $p;
          }
          tmp_0 = tmp_1;
        }
        var tmp$ret$3 = tmp_0;
        var tmp$ret$2 = new TypeInfo(tmp, tmp$ret$3);
        $this$request.qtx(tmp$ret$2);
      } else {
        if (body instanceof OutgoingContent) {
          $this$request.bts_1 = body;
          $this$request.qtx(null);
        } else {
          $this$request.bts_1 = body;
          // Inline function 'io.ktor.util.reflect.typeInfo' call
          var tmp_2 = getKClass(JsonObject);
          // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
          var tmp_3;
          try {
            tmp_3 = createKType(getKClass(JsonObject), arrayOf([]), false);
          } catch ($p_0) {
            var tmp_4;
            if ($p_0 instanceof Error) {
              var _unused_var__etf5q3_0 = $p_0;
              tmp_4 = null;
            } else {
              throw $p_0;
            }
            tmp_3 = tmp_4;
          }
          var tmp$ret$5 = tmp_3;
          var tmp$ret$4 = new TypeInfo(tmp_2, tmp$ret$5);
          $this$request.qtx(tmp$ret$4);
        }
      }
      return Unit_instance;
    };
  }
  function BucketApiImpl$normalDownloadRequest$lambda(this$0, $path, $public, $downloadOptions) {
    return function ($this$rawRequest) {
      this$0.bx6($this$rawRequest, $path, $public, $downloadOptions);
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = $downloadOptions.dx6_1.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        element($this$rawRequest);
      }
      return Unit_instance;
    };
  }
  function BucketApiImpl$uploadOrUpdate$lambda($method, this$0, $path, $data, $optionBuilder) {
    return function ($this$request) {
      $this$request.ztr_1 = $method;
      defaultUploadRequest(this$0, $this$request, $path, $data, $optionBuilder);
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = $optionBuilder.ax6_1.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        element($this$request);
      }
      return Unit_instance;
    };
  }
  function BucketApiImpl$defaultUploadRequest$1($optionBuilder, $path, $data) {
    this.hx6_1 = $data;
    ReadChannelContent.call(this);
    var tmp = this;
    var tmp0_elvis_lhs = $optionBuilder.zx5_1;
    tmp.fx6_1 = tmp0_elvis_lhs == null ? defaultForFilePath(Companion_getInstance(), $path) : tmp0_elvis_lhs;
    this.gx6_1 = $data.jx6_1;
  }
  protoOf(BucketApiImpl$defaultUploadRequest$1).vt7 = function () {
    return this.fx6_1;
  };
  protoOf(BucketApiImpl$defaultUploadRequest$1).wt7 = function () {
    return this.gx6_1;
  };
  protoOf(BucketApiImpl$defaultUploadRequest$1).at8 = function () {
    return this.hx6_1.ix6_1;
  };
  function $deleteCOROUTINE$(_this__u8e3s4, paths, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.sx6_1 = _this__u8e3s4;
    this.tx6_1 = paths;
  }
  protoOf($deleteCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp0 = this.sx6_1.tx5_1;
            var tmp2 = this.sx6_1.qx5_1;
            var builder = new JsonObjectBuilder();
            putJsonArray(builder, 'prefixes', BucketApiImpl$delete$lambda(this.tx6_1));
            var tmp4 = builder.wmh();
            var contentType = Application_getInstance().ksv_1;
            this.n9_1 = 1;
            suspendResult = tmp0.wvm(tmp2, BucketApiImpl$delete$lambda_0(contentType, tmp4), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $copyCOROUTINE$(_this__u8e3s4, from, to, destinationBucket, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.cx7_1 = _this__u8e3s4;
    this.dx7_1 = from;
    this.ex7_1 = to;
    this.fx7_1 = destinationBucket;
  }
  protoOf($copyCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp0 = this.cx7_1.tx5_1;
            var builder = new JsonObjectBuilder();
            put(builder, 'bucketId', this.cx7_1.qx5_1);
            put(builder, 'sourceKey', this.dx7_1);
            put(builder, 'destinationKey', this.ex7_1);
            var tmp0_safe_receiver = this.fx7_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              put(builder, 'destinationBucket', tmp0_safe_receiver);
            }

            var tmp4 = builder.wmh();
            var contentType = Application_getInstance().ksv_1;
            this.n9_1 = 1;
            suspendResult = tmp0.wvm('copy', BucketApiImpl$copy$lambda(contentType, tmp4), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $normalDownloadRequestCOROUTINE$(_this__u8e3s4, path, public_0, options, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.mx5_1 = _this__u8e3s4;
    this.nx5_1 = path;
    this.ox5_1 = public_0;
    this.px5_1 = options;
  }
  protoOf($normalDownloadRequestCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp0 = new DownloadOptionBuilder();
            this.px5_1(tmp0);
            var downloadOptions = tmp0;
            this.n9_1 = 1;
            suspendResult = this.mx5_1.tx5_1.bwg(BucketApiImpl$normalDownloadRequest$lambda(this.mx5_1, this.nx5_1, this.ox5_1, downloadOptions), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_0 = suspendResult;
            this.n9_1 = 2;
            var tmp_0 = this_0.mtt();
            var tmp_1 = PrimitiveClasses_getInstance().vc();
            var tmp_2;
            try {
              tmp_2 = createKType(PrimitiveClasses_getInstance().vc(), arrayOf([]), false);
            } catch ($p) {
              var tmp_3;
              if ($p instanceof Error) {
                var _unused_var__etf5q3 = $p;
                tmp_3 = null;
              } else {
                throw $p;
              }
              tmp_2 = tmp_3;
            }

            suspendResult = tmp_0.jtt(new TypeInfo(tmp_1, tmp_2), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return (!(suspendResult == null) ? isByteArray(suspendResult) : false) ? suspendResult : THROW_CCE();
          case 3:
            throw this.q9_1;
        }
      } catch ($p_0) {
        var e = $p_0;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $uploadOrUpdateCOROUTINE$(_this__u8e3s4, method, url, data, options, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ox7_1 = _this__u8e3s4;
    this.px7_1 = method;
    this.qx7_1 = url;
    this.rx7_1 = data;
    this.sx7_1 = options;
  }
  protoOf($uploadOrUpdateCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.tx7_1 = substringBeforeLast(substringAfterLast(this.qx7_1, _Char___init__impl__6a9atx(47)), '?');
            var tmp0 = new UploadOptionBuilder(this.ox7_1.rx5_1.rvz());
            this.sx7_1(tmp0);
            var optionBuilder = tmp0;
            this.n9_1 = 1;
            suspendResult = this.ox7_1.tx5_1.wvm(this.qx7_1, BucketApiImpl$uploadOrUpdate$lambda(this.px7_1, this.ox7_1, this.tx7_1, this.rx7_1, optionBuilder), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_0 = suspendResult;
            this.xx7_1 = null;
            this.n9_1 = 2;
            suspendResult = bodyAsText(this_0, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.vx7_1 = suspendResult;
            this.wx7_1 = !(this.xx7_1 == null) ? ' in ' + this.xx7_1 : '';
            this.o9_1 = 3;
            var tmp_0 = this;
            var tmp0_0 = get_supabaseJson();
            var string = this.vx7_1;
            var this_1 = tmp0_0.c75();
            var this_2 = serializer(this_1, createKType(getKClass(JsonObject), arrayOf([]), false));
            tmp_0.ux7_1 = tmp0_0.c72(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), string);
            this.o9_1 = 5;
            this.n9_1 = 4;
            continue $sm;
          case 3:
            this.o9_1 = 5;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof MissingFieldException) {
              var e = this.q9_1;
              var tmp_2 = this;
              throw new SupabaseEncodingException("Couldn't decode payload" + this.wx7_1 + ' as ' + getKClass(JsonObject).o() + '. Input: ' + replace(this.vx7_1, '\n', ''));
            } else {
              throw this.q9_1;
            }

          case 4:
            this.o9_1 = 5;
            var response = this.ux7_1;
            var tmp0_safe_receiver = response.je('Key');
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
            var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.rj3();
            var tmp_3;
            if (tmp2_elvis_lhs == null) {
              var message = 'Expected a key in a upload response';
              throw IllegalStateException_init_$Create$(toString(message));
            } else {
              tmp_3 = tmp2_elvis_lhs;
            }

            var key = tmp_3;
            var tmp3_safe_receiver = response.je('Id');
            var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : get_jsonPrimitive(tmp3_safe_receiver);
            var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.rj3();
            var tmp_4;
            if (tmp5_elvis_lhs == null) {
              var message_0 = 'Expected an id in a upload response';
              throw IllegalStateException_init_$Create$(toString(message_0));
            } else {
              tmp_4 = tmp5_elvis_lhs;
            }

            var id = tmp_4;
            return new FileUploadResponse(id, this.tx7_1, key);
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 5) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function BucketApiImpl(bucketId, storage, api, resumableCache) {
    this.qx5_1 = bucketId;
    this.rx5_1 = storage;
    this.sx5_1 = Companion_getInstance_1().yt1_1;
    var tmp = this;
    tmp.tx5_1 = api.cwg(BucketApiImpl$api$lambda(this));
    this.ux5_1 = this.rx5_1.yvn();
    this.vx5_1 = new ResumableClientImpl(this, resumableCache);
  }
  protoOf(BucketApiImpl).yvn = function () {
    return this.ux5_1;
  };
  protoOf(BucketApiImpl).wx4 = function (path, data, options, $completion) {
    return this.yx7(Companion_getInstance_0().ft2_1, defaultUploadUrl(this, path), data, options, $completion);
  };
  protoOf(BucketApiImpl).xx4 = function (paths, $completion) {
    var tmp = new $deleteCOROUTINE$(this, paths, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BucketApiImpl).zx4 = function (from, to, destinationBucket, $completion) {
    var tmp = new $copyCOROUTINE$(this, from, to, destinationBucket, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BucketApiImpl).bx5 = function (path, options, $completion) {
    return normalDownloadRequest(this, path, true, options, $completion);
  };
  protoOf(BucketApiImpl).bx6 = function (_this__u8e3s4, path, public_0, options) {
    var tmp0 = new ImageTransformation();
    // Inline function 'kotlin.apply' call
    options.cx6_1(tmp0);
    var transformation = tmp0.ex8();
    var tmp;
    switch (public_0) {
      case true:
        tmp = isBlank(transformation) ? this.dx5(path) : this.fx8(path, options.cx6_1);
        break;
      case false:
        tmp = isBlank(transformation) ? this.hx8(path) : this.gx8(path, options.cx6_1);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var url_0 = tmp;
    _this__u8e3s4.ztr_1 = Companion_getInstance_0().et2_1;
    url(_this__u8e3s4, url_0);
  };
  protoOf(BucketApiImpl).yx7 = function (method, url, data, options, $completion) {
    var tmp = new $uploadOrUpdateCOROUTINE$(this, method, url, data, options, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BucketApiImpl).hx8 = function (path) {
    return this.rx5_1.vvn('object/authenticated/' + this.qx5_1 + '/' + path);
  };
  protoOf(BucketApiImpl).dx5 = function (path) {
    return this.rx5_1.vvn('object/public/' + this.qx5_1 + '/' + path);
  };
  protoOf(BucketApiImpl).gx8 = function (path, transform) {
    // Inline function 'kotlin.apply' call
    var this_0 = new ImageTransformation();
    transform(this_0);
    var transformation = this_0.ex8();
    var tmp;
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(transformation)) {
      tmp = '?' + transformation;
    } else {
      tmp = '';
    }
    return this.rx5_1.vvn('render/image/authenticated/' + this.qx5_1 + '/' + path + tmp);
  };
  protoOf(BucketApiImpl).fx8 = function (path, transform) {
    // Inline function 'kotlin.apply' call
    var this_0 = new ImageTransformation();
    transform(this_0);
    var transformation = this_0.ex8();
    var tmp;
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(transformation)) {
      tmp = '?' + transformation;
    } else {
      tmp = '';
    }
    return this.rx5_1.vvn('render/image/public/' + this.qx5_1 + '/' + path + tmp);
  };
  function DownloadOptionBuilder$_init_$lambda_c4kxfx(_this__u8e3s4) {
    return Unit_instance;
  }
  function DownloadOptionBuilder(transform, httpRequestOverrides) {
    var tmp;
    if (transform === VOID) {
      tmp = DownloadOptionBuilder$_init_$lambda_c4kxfx;
    } else {
      tmp = transform;
    }
    transform = tmp;
    var tmp_0;
    if (httpRequestOverrides === VOID) {
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp_0 = ArrayList_init_$Create$();
    } else {
      tmp_0 = httpRequestOverrides;
    }
    httpRequestOverrides = tmp_0;
    this.cx6_1 = transform;
    this.dx6_1 = httpRequestOverrides;
  }
  function FileUploadResponse(id, path, key) {
    id = id === VOID ? null : id;
    key = key === VOID ? null : key;
    this.ix8_1 = id;
    this.jx8_1 = path;
    this.kx8_1 = key;
  }
  protoOf(FileUploadResponse).toString = function () {
    return 'FileUploadResponse(id=' + this.ix8_1 + ', path=' + this.jx8_1 + ', key=' + this.kx8_1 + ')';
  };
  protoOf(FileUploadResponse).hashCode = function () {
    var result = this.ix8_1 == null ? 0 : getStringHashCode(this.ix8_1);
    result = imul(result, 31) + getStringHashCode(this.jx8_1) | 0;
    result = imul(result, 31) + (this.kx8_1 == null ? 0 : getStringHashCode(this.kx8_1)) | 0;
    return result;
  };
  protoOf(FileUploadResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FileUploadResponse))
      return false;
    if (!(this.ix8_1 == other.ix8_1))
      return false;
    if (!(this.jx8_1 === other.jx8_1))
      return false;
    if (!(this.kx8_1 == other.kx8_1))
      return false;
    return true;
  };
  function Companion() {
    Companion_instance = this;
    this.lx8_1 = numberRangeToNumber(1, 100);
  }
  var Companion_instance;
  function Companion_getInstance_5() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function ImageTransformation() {
    Companion_getInstance_5();
    this.zx7_1 = null;
    this.ax8_1 = null;
    this.bx8_1 = null;
    this.cx8_1 = null;
    this.dx8_1 = null;
  }
  protoOf(ImageTransformation).ex8 = function () {
    var builder = ParametersBuilder();
    var tmp0_safe_receiver = this.zx7_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      builder.fsq('width', tmp0_safe_receiver.toString());
    }
    var tmp1_safe_receiver = this.ax8_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      builder.fsq('height', tmp1_safe_receiver.toString());
    }
    var tmp2_safe_receiver = this.dx8_1;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$6 = tmp2_safe_receiver.z_1.toLowerCase();
      builder.fsq('resize', tmp$ret$6);
    }
    var tmp3_safe_receiver = this.bx8_1;
    if (tmp3_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      builder.fsq('quality', tmp3_safe_receiver.toString());
    }
    var tmp4_safe_receiver = this.cx8_1;
    if (tmp4_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      builder.fsq('format', tmp4_safe_receiver);
    }
    return formUrlEncode(builder.g3d());
  };
  function Resumable(cache, retryTimeout, onlyUpdateStateAfterChunk) {
    cache = cache === VOID ? null : cache;
    var tmp;
    if (retryTimeout === VOID) {
      // Inline function 'kotlin.time.Companion.seconds' call
      Companion_getInstance_2();
      tmp = toDuration(5, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = retryTimeout;
    }
    retryTimeout = tmp;
    onlyUpdateStateAfterChunk = onlyUpdateStateAfterChunk === VOID ? false : onlyUpdateStateAfterChunk;
    this.mx8_1 = cache;
    this.nx8_1 = retryTimeout;
    this.ox8_1 = onlyUpdateStateAfterChunk;
    this.px8_1 = new Long(6291456, 0);
  }
  protoOf(Resumable).toString = function () {
    return 'Resumable(cache=' + toString_0(this.mx8_1) + ', retryTimeout=' + Duration__toString_impl_8d916b(this.nx8_1) + ', onlyUpdateStateAfterChunk=' + this.ox8_1 + ')';
  };
  protoOf(Resumable).hashCode = function () {
    var result = this.mx8_1 == null ? 0 : hashCode(this.mx8_1);
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.nx8_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ox8_1) | 0;
    return result;
  };
  protoOf(Resumable).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Resumable))
      return false;
    if (!equals(this.mx8_1, other.mx8_1))
      return false;
    if (!equals(this.nx8_1, other.nx8_1))
      return false;
    if (!(this.ox8_1 === other.ox8_1))
      return false;
    return true;
  };
  function Config(transferTimeout, resumable, serializer, requireValidSession) {
    var tmp;
    if (transferTimeout === VOID) {
      // Inline function 'kotlin.time.Companion.seconds' call
      Companion_getInstance_2();
      tmp = toDuration(120, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = transferTimeout;
    }
    transferTimeout = tmp;
    resumable = resumable === VOID ? new Resumable() : resumable;
    serializer = serializer === VOID ? null : serializer;
    requireValidSession = requireValidSession === VOID ? false : requireValidSession;
    MainConfig.call(this);
    this.sx8_1 = transferTimeout;
    this.tx8_1 = resumable;
    this.ux8_1 = serializer;
    this.vx8_1 = requireValidSession;
  }
  protoOf(Config).tvz = function () {
    return this.vx8_1;
  };
  protoOf(Config).toString = function () {
    return 'Config(transferTimeout=' + Duration__toString_impl_8d916b(this.sx8_1) + ', resumable=' + this.tx8_1.toString() + ', serializer=' + toString_0(this.ux8_1) + ', requireValidSession=' + this.vx8_1 + ')';
  };
  protoOf(Config).hashCode = function () {
    var result = Duration__hashCode_impl_u4exz6(this.sx8_1);
    result = imul(result, 31) + this.tx8_1.hashCode() | 0;
    result = imul(result, 31) + (this.ux8_1 == null ? 0 : hashCode(this.ux8_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.vx8_1) | 0;
    return result;
  };
  protoOf(Config).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Config))
      return false;
    if (!equals(this.sx8_1, other.sx8_1))
      return false;
    if (!this.tx8_1.equals(other.tx8_1))
      return false;
    if (!equals(this.ux8_1, other.ux8_1))
      return false;
    if (!(this.vx8_1 === other.vx8_1))
      return false;
    return true;
  };
  function Companion_0() {
    Companion_instance_0 = this;
    this.wx8_1 = 'storage';
    this.xx8_1 = Companion_getInstance_3().ovj('Supabase-Storage');
    this.yx8_1 = 1;
    this.zx8_1 = new Long(6291456, 0);
  }
  protoOf(Companion_0).t1 = function () {
    return this.wx8_1;
  };
  protoOf(Companion_0).ax9 = function (init) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Config();
    init(this_0);
    return this_0;
  };
  protoOf(Companion_0).ovl = function (init) {
    return this.ax9(init);
  };
  protoOf(Companion_0).bx9 = function (supabaseClient, config) {
    return new StorageImpl(supabaseClient, config);
  };
  protoOf(Companion_0).xvk = function (supabaseClient, config) {
    return this.bx9(supabaseClient, config instanceof Config ? config : THROW_CCE());
  };
  var Companion_instance_0;
  function Companion_getInstance_6() {
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function Storage() {
  }
  function get_storage(_this__u8e3s4) {
    var tmp0 = _this__u8e3s4.tvj();
    // Inline function 'io.github.jan.supabase.plugins.PluginManager.getPlugin' call
    var provider = Companion_getInstance_6();
    // Inline function 'io.github.jan.supabase.plugins.PluginManager.getPluginOrNull' call
    var tmp = tmp0.wvk_1.w2(provider.t1());
    var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, Storage) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = 'Plugin ' + provider.t1() + ' not installed or not of type ' + getKClass(Storage).o() + '. Consider installing ' + getKClass(Storage).o() + ' within your SupabaseClientBuilder';
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return tmp_0;
  }
  function StorageImpl$api$lambda$lambda(this$0) {
    return function ($this$timeout) {
      $this$timeout.fui(_Duration___get_inWholeMilliseconds__impl__msfiry(this$0.dx9_1.sx8_1));
      return Unit_instance;
    };
  }
  function StorageImpl$api$lambda(this$0) {
    return function ($this$authenticatedSupabaseApi) {
      timeout($this$authenticatedSupabaseApi, StorageImpl$api$lambda$lambda(this$0));
      return Unit_instance;
    };
  }
  function $parseErrorResponseCOROUTINE$(_this__u8e3s4, response, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.qx9_1 = _this__u8e3s4;
    this.rx9_1 = response;
  }
  protoOf($parseErrorResponseCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.sx9_1 = this.rx9_1.zbq();
            var this_0 = this.rx9_1;
            this.n9_1 = 1;
            suspendResult = bodyAsText(this_0, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.ux9_1 = suspendResult;
            this.o9_1 = 2;
            var tmp_0 = this;
            var tmp0 = get_supabaseJson();
            var string = this.ux9_1;
            var this_1 = tmp0.c75();
            var this_2 = serializer(this_1, createKType(getKClass(StorageErrorResponse), arrayOf([]), false));
            tmp_0.tx9_1 = tmp0.c72(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), string);
            this.o9_1 = 4;
            this.n9_1 = 3;
            continue $sm;
          case 2:
            this.o9_1 = 4;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof SerializationException) {
              var e = this.q9_1;
              var tmp_2 = this;
              var tmp0_0 = Companion_getInstance_3().evj_1;
              var level = LogLevel_INFO_getInstance();
              var tmp0_elvis_lhs = tmp0_0.fsu();
              if (level.i3(tmp0_elvis_lhs == null ? Companion_getInstance_3().dvj_1 : tmp0_elvis_lhs) >= 0) {
                tmp0_0.fvj(level, e, 'Could not decode ' + this.ux9_1 + ' as ' + toString(getKClass(StorageErrorResponse)) + '.');
              }
              tmp_2.tx9_1 = null;
              this.n9_1 = 3;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            this.o9_1 = 4;
            var tmp0_elvis_lhs_0 = this.tx9_1;
            var error = tmp0_elvis_lhs_0 == null ? new StorageErrorResponse(this.rx9_1.zbq().yt2_1, 'Unknown error', '') : tmp0_elvis_lhs_0;
            if (!this.sx9_1.equals(Companion_getInstance_4().ut3_1))
              return new UnknownRestException('Unknown error response ' + error.toString(), this.rx9_1);
            var tmp1_subject = error.vx9_1;
            if (tmp1_subject === Companion_getInstance_4().vt3_1.yt2_1)
              throw new UnauthorizedRestException(error.wx9_1, this.rx9_1, error.xx9_1);
            else if (tmp1_subject === Companion_getInstance_4().ut3_1.yt2_1)
              throw new BadRequestRestException(error.wx9_1, this.rx9_1, error.xx9_1);
            else if (tmp1_subject === Companion_getInstance_4().yt3_1.yt2_1)
              throw new NotFoundRestException(error.wx9_1, this.rx9_1, error.xx9_1);
            else
              throw new UnknownRestException(error.xx9_1, this.rx9_1);
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 4) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function StorageImpl(supabaseClient, config) {
    this.cx9_1 = supabaseClient;
    this.dx9_1 = config;
    var tmp = this;
    var tmp0_elvis_lhs = this.dx9_1.ux8_1;
    tmp.ex9_1 = tmp0_elvis_lhs == null ? this.cx9_1.wvj() : tmp0_elvis_lhs;
    var tmp_0 = this;
    tmp_0.fx9_1 = authenticatedSupabaseApi(this.cx9_1, this, StorageImpl$api$lambda(this));
    this.gx9_1 = new StorageAnalyticsClientImpl(this.fx9_1.mwc('iceberg'));
    this.hx9_1 = new StorageVectorsClientImpl(this.fx9_1.mwc('vector'));
  }
  protoOf(StorageImpl).yvn = function () {
    return this.cx9_1;
  };
  protoOf(StorageImpl).ebw = function () {
    return this.dx9_1;
  };
  protoOf(StorageImpl).uvn = function () {
    return Companion_getInstance_6().wx8_1;
  };
  protoOf(StorageImpl).tvn = function () {
    return 1;
  };
  protoOf(StorageImpl).rvz = function () {
    return this.ex9_1;
  };
  protoOf(StorageImpl).je = function (bucketId) {
    var tmp = this.fx9_1.mwc('object');
    var tmp0_elvis_lhs = this.dx9_1.tx8_1.mx8_1;
    return new BucketApiImpl(bucketId, this, tmp, tmp0_elvis_lhs == null ? createDefaultResumableCache() : tmp0_elvis_lhs);
  };
  protoOf(StorageImpl).svn = function (response, $completion) {
    var tmp = new $parseErrorResponseCOROUTINE$(this, response, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  function Companion_1() {
  }
  var Companion_instance_1;
  function Companion_getInstance_7() {
    return Companion_instance_1;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.github.jan.supabase.storage.StorageErrorResponse', this, 3);
    tmp0_serialDesc.a7c('statusCode', false);
    tmp0_serialDesc.a7c('error', false);
    tmp0_serialDesc.a7c('message', false);
    this.yx9_1 = tmp0_serialDesc;
  }
  protoOf($serializer).zx9 = function (encoder, value) {
    var tmp0_desc = this.yx9_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    tmp1_output.x75(tmp0_desc, 0, value.vx9_1);
    tmp1_output.c76(tmp0_desc, 1, value.wx9_1);
    tmp1_output.c76(tmp0_desc, 2, value.xx9_1);
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer).z70 = function (encoder, value) {
    return this.zx9(encoder, value instanceof StorageErrorResponse ? value : THROW_CCE());
  };
  protoOf($serializer).a71 = function (decoder) {
    var tmp0_desc = this.yx9_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.n74(tmp0_desc);
    if (tmp7_input.d75()) {
      tmp4_local0 = tmp7_input.s74(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.x74(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.x74(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.s74(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.x74(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.x74(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.o74(tmp0_desc);
    return StorageErrorResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer).y70 = function () {
    return this.yx9_1;
  };
  protoOf($serializer).t7c = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance;
  function $serializer_getInstance() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function StorageErrorResponse_init_$Init$(seen0, statusCode, error, message, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance().yx9_1);
    }
    $this.vx9_1 = statusCode;
    $this.wx9_1 = error;
    $this.xx9_1 = message;
    return $this;
  }
  function StorageErrorResponse_init_$Create$(seen0, statusCode, error, message, serializationConstructorMarker) {
    return StorageErrorResponse_init_$Init$(seen0, statusCode, error, message, serializationConstructorMarker, objectCreate(protoOf(StorageErrorResponse)));
  }
  function StorageErrorResponse(statusCode, error, message) {
    this.vx9_1 = statusCode;
    this.wx9_1 = error;
    this.xx9_1 = message;
  }
  protoOf(StorageErrorResponse).toString = function () {
    return 'StorageErrorResponse(statusCode=' + this.vx9_1 + ', error=' + this.wx9_1 + ', message=' + this.xx9_1 + ')';
  };
  protoOf(StorageErrorResponse).hashCode = function () {
    var result = this.vx9_1;
    result = imul(result, 31) + getStringHashCode(this.wx9_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.xx9_1) | 0;
    return result;
  };
  protoOf(StorageErrorResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof StorageErrorResponse))
      return false;
    if (!(this.vx9_1 === other.vx9_1))
      return false;
    if (!(this.wx9_1 === other.wx9_1))
      return false;
    if (!(this.xx9_1 === other.xx9_1))
      return false;
    return true;
  };
  function UploadData(stream, size) {
    this.ix6_1 = stream;
    this.jx6_1 = size;
  }
  protoOf(UploadData).toString = function () {
    return 'UploadData(stream=' + toString(this.ix6_1) + ', size=' + this.jx6_1.toString() + ')';
  };
  protoOf(UploadData).hashCode = function () {
    var result = hashCode(this.ix6_1);
    result = imul(result, 31) + this.jx6_1.hashCode() | 0;
    return result;
  };
  protoOf(UploadData).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UploadData))
      return false;
    if (!equals(this.ix6_1, other.ix6_1))
      return false;
    if (!equalsLong(this.jx6_1, other.jx6_1))
      return false;
    return true;
  };
  function UploadOptionBuilder(serializer, upsert, userMetadata, contentType, httpRequestOverrides) {
    upsert = upsert === VOID ? false : upsert;
    userMetadata = userMetadata === VOID ? null : userMetadata;
    contentType = contentType === VOID ? null : contentType;
    var tmp;
    if (httpRequestOverrides === VOID) {
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp = ArrayList_init_$Create$();
    } else {
      tmp = httpRequestOverrides;
    }
    httpRequestOverrides = tmp;
    this.wx5_1 = serializer;
    this.xx5_1 = upsert;
    this.yx5_1 = userMetadata;
    this.zx5_1 = contentType;
    this.ax6_1 = httpRequestOverrides;
  }
  function StorageAnalyticsClientImpl(api) {
    this.axa_1 = api;
  }
  function MemoryResumableCache(map) {
    map = map === VOID ? new AtomicMutableMap([]) : map;
    this.bxa_1 = map;
  }
  function ResumableClientImpl(storageApi, cache) {
    this.cxa_1 = storageApi;
    this.dxa_1 = cache;
    this.exa_1 = this.cxa_1.yvn().uvj().fvm_1;
    this.fxa_1 = get_storage(this.cxa_1.yvn()).vvn('upload/resumable');
    this.gxa_1 = get_storage(this.cxa_1.yvn()).ebw().tx8_1.px8_1;
  }
  function StorageVectorsClientImpl(api) {
    this.hxa_1 = api;
  }
  function createDefaultResumableCache() {
    return !PlatformUtils_getInstance().osp_1 ? new SettingsResumableCache() : new MemoryResumableCache();
  }
  function SettingsResumableCache(settings) {
    settings = settings === VOID ? Settings() : settings;
    this.ixa_1 = toSuspendSettings(settings);
  }
  //region block: post-declaration
  protoOf(BucketApiImpl).ax5 = copy$default;
  protoOf(BucketApiImpl).cx5 = downloadPublic$default;
  protoOf(BucketApiImpl).vx4 = upload;
  protoOf(BucketApiImpl).yx4 = delete_0;
  protoOf(Companion_0).pvl = setup;
  protoOf(StorageImpl).xwu = from;
  protoOf(StorageImpl).vvn = resolveUrl;
  protoOf(StorageImpl).odl = init;
  protoOf($serializer).u7c = typeParametersSerializers;
  //endregion
  //region block: init
  Companion_instance_1 = new Companion_1();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Companion_getInstance_6;
  _.$_$.b = Storage;
  _.$_$.c = get_storage;
  //endregion
  return _;
}));

//# sourceMappingURL=supabase-kt-storage-kt.js.map
